(() => {
  'use strict';
  if (window.MKCartPreviewCompatV41) return;
  window.MKCartPreviewCompatV41 = true;
  if ('commandForElement' in HTMLButtonElement.prototype && 'command' in HTMLButtonElement.prototype) return;
  document.addEventListener('click', event => {
    const button = event.target instanceof Element ? event.target.closest('button[commandfor][command]') : null;
    if (!button || !button.closest('.mk-cart-setup')) return;
    const command = button.getAttribute('command');
    if (command !== 'show-modal' && command !== 'close') return;
    const dialog = document.getElementById(button.getAttribute('commandfor'));
    if (!dialog || !dialog.matches('dialog.mk-cart-setup__preview')) return;
    event.preventDefault();
    if (command === 'close') {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      return;
    }
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      const details = dialog.querySelector('a.mk-cart-setup__choose[href]');
      if (details) window.location.assign(details.href);
    }
  });
})();
